import axiosClient from './axiosClient'

const reportApi = {
  getUsedInvoices: (params, signal) => {
    const url = '/invoice/list-all'
    return axiosClient.get(url, { params, signal })
  },

  getIssuedInvoice: (params, signal) => {
    const url = '/statistic/get-invoice-template-serial-stats'
    return axiosClient.get(url, { params, signal })
  },

  getDetailInvoices: (params, signal) => {
    const url = '/statistic/get-invoice-stats-detail'
    return axiosClient.get(url, { params, signal })
  },

  exportData: (params) => {
    const url = '/statistic/export-invoice-stats-detail'
    return axiosClient.get(url, { params, responseType: 'blob' })
  },

  getReportBytax: (params, signal) => {
    const url = '/statistic/get-invoice-stats-by-tax'
    return axiosClient.get(url, { params, signal })
  },

  getInvoiceStatFile: (params) => {
    const url = '/statistic/export-invoice-stats-detail'
    return axiosClient.get(url, { params, responseType: 'blob' })
  },

  exportReportFile: (body, params, responseType) => {
    const url = '/statistic/downloadFile'
    if (responseType) {
      return axiosClient.post(url, body, {
        params: params, // Đính kèm params vào URL
        responseType,
      })
    } else {
      return axiosClient.post(url, body, {
        params: params, // Đính kèm params vào URL
      })
    }
  },

  downloadFilePublic: (params) => {
    if (params?.type == 'file') {
      const url = '/fileTemplate/getFileByCode'
      return axiosClient.get(url, { params, responseType: 'blob' })
    } else {
      const url = '/fileTemplate/getFileByCode'
      return axiosClient.get(url, { params })
    }
  },
  getOveralObstetrics: (params, signal) => {
    const url = '/statistic/get-overal-obstetrics'
    return axiosClient.get(url, { params, signal })
  },
}

export default reportApi
